import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { addNewNotification } from '../../actions'

const NotificationForm = ({ selectedUsers, setShowForm }) => {

    const [notificationForm, setNotificationForm] = useState({})

    const dispatch = useDispatch()

    const onChangehandler = e => {
        const {name, value} = e.target
        setNotificationForm({...notificationForm, [name]:value})
    }

    const onSubmitHandler = () => {
        if (!notificationForm?.title || !notificationForm?.body) {
            Swal.fire({ title: 'Please enter both a title and a message', icon: 'warning', confirmButtonColor: '#3ab1f7' })
            return
        }
        const payload = {
            title: notificationForm?.title,
            body: notificationForm?.body,
            userIds: selectedUsers?.length > 0 ? selectedUsers : null
        }
        dispatch(addNewNotification(payload))
        Swal.fire({ title: 'Notification sent', icon: 'success', confirmButtonColor: '#3ab1f7' })
        setNotificationForm({})
        if (typeof setShowForm === 'function') setShowForm(false)
    }

  return (
    <div className='main-body'>
        <div className='page-wrapper'>
        <div className='page-header'>
        <div className='row align-items-end'>
        <div className='col-lg-8'>
            <div className='page-header-title'>
            <div className='d-inline'>
                <h4>Send Notification</h4>
            </div>
        </div>
        </div>
        <div className="col-lg-4">
        <div className="page-header-breadcrumb">
            <ul className='breadcrumb-title'>
            <li className='breadcrumb-item' onClick={() => setShowForm(false)}>
                {/* <Link to='/'> */}
                <i className='feather icon-home'></i>{' '}
            </li>
            <li className='breadcrumb-item'>Packages
                {/* <Link to='/CarDetail/CarModel'>Packages</Link> */}
            </li>
            </ul>

        </div>
        </div>
        </div>
        </div>
        <div className='page-body'>
        <div className='row'>
        <div className='col-sm-12'>
        <div className='card card-border-default'>
            <div className='card-block'>
            
            <div className='tab-content tabs'>
            <div
                            className='tab-pane  active'
                            id={'car_user_'}
                            role='tabpanel'
                            aria-labelledby=''>
                              <div className=''>
                  
                        <div className='card-body'>
                          <div className='row'>
                            <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Name</label>
                                <div className='col-sm-9'>
                                  <input
                                    onChange={onChangehandler}
                                    type='text'
                                    className='form-control'
                                    name='title'
                                    // value={}
                                    placeholder='Enter Notification Title'
                                    // onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Description</label>
                                <div className='col-sm-9'>
                                  <input
                                    onChange={onChangehandler}
                                    type='text'
                                    className='form-control'
                                    name='body'
                                    // value={}
                                    placeholder='Enter Notification Title'
                                    // onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
                            </div>
          
                            <div className='card-footer'>
                          <div className='row float-right p-3'>
                            <button
                                onClick={onSubmitHandler}
                              className='btn btn-grd-disabled mr-2'>
                              <i className='icofont icofont-save'></i> Save</button>
                            {/* <Link to={'/CarDetail/CarModel'} className='btn btn-outline-dark'> */}
                              <button onClick={()=>setShowForm(false) }>Cancel</button>
                            {/* </Link> */}
                          </div>
                        </div>
                            </div>
                            </div>
                            </div>
            </div>
            </div>
        </div>
        </div>
        </div>
        </div>
        </div>
    </div>

  )
}

export default NotificationForm